import { createI18n } from 'vue-i18n'
import en from './locales/en'
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'
import zhHK from './locales/zh-HK'
import de from './locales/de'
import es from './locales/es'
import fr from './locales/fr'
import it from './locales/it'
import ja from './locales/ja'
import ko from './locales/ko'
import pt from './locales/pt'
import ru from './locales/ru'

const supportedLocales = ['en', 'zh-CN', 'zh-TW', 'zh-HK', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru']

function getBrowserLocale () {
  const browserLang = navigator.language || navigator.userLanguage
  const lang = browserLang.toLowerCase()

  if (lang.startsWith('zh')) {
    if (lang.includes('tw') || lang.includes('hk')) {
      return lang.includes('hk') ? 'zh-HK' : 'zh-TW'
    }
    if (lang.includes('cn') || lang === 'zh') {
      return 'zh-CN'
    }
    return 'zh-CN'
  }

  const primaryLang = lang.split('-')[0]
  if (supportedLocales.includes(primaryLang)) {
    return primaryLang
  }

  return 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'zh-HK': zhHK,
    de,
    es,
    fr,
    it,
    ja,
    ko,
    pt,
    ru
  }
})

export function getCurrentLocale () {
  return i18n.global.locale.value
}

export function setLocale (locale) {
  if (supportedLocales.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('app-locale', locale)
  }
}

export function initLocale () {
  const savedLocale = localStorage.getItem('app-locale')
  if (savedLocale && supportedLocales.includes(savedLocale)) {
    i18n.global.locale.value = savedLocale
  }
}

export { supportedLocales }
export default i18n
